interface IFont {
  label: string;
  value: string;
}

export const takeGoogleFontsUrl = (fontsArray: IFont[]) => {
  let fontHref = 'https://fonts.googleapis.com/css2';
  fontsArray.forEach((font, index) => {
    const convertedFontName = font.label.replace(/\s+/g, '+');
    if (index === 0) fontHref += `?family=${convertedFontName}`;
    else if (index === fontsArray.length - 1) fontHref += `&family=${convertedFontName}&display=swap`;
    else fontHref += `&family=${convertedFontName}`;
  });
  return fontHref;
};
